import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop'; // <-- Import the new component
import FloatingWhatsApp from './components/ui/FloatingWhatsApp';
// Import Page Components
import Home from './pages/Home';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import Contact from './pages/Contact';

// Legal Stuff
import LegalPage from './pages/LegalPage';
import { privacyPolicyContent, refundPolicyContent, termsOfServiceContent } from './data/legalData';

function App() {
  const currentDate = "June 2026"; 

  return (
    <Router>
      <ScrollToTop /> {/* <-- Add it right here, inside Router but above everything else */}
      
      <div className="min-h-screen bg-royal-navy text-white pt-20">
        <Navbar />

        <main>
          {/* ... all your Routes ... */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<LegalPage title="Privacy Policy" lastUpdated={currentDate} content={privacyPolicyContent} />} />
            <Route path="/refund-policy" element={<LegalPage title="Refund Policy" lastUpdated={currentDate} content={refundPolicyContent} />} />
            <Route path="/terms-of-service" element={<LegalPage title="Terms of Service" lastUpdated={currentDate} content={termsOfServiceContent} />} />
          </Routes>
        </main>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </Router>
  );
}

export default App;